var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useState, } from 'react';
import { CFButton } from '../../components';
import { commonAttrs } from '../../utils';
export const CFDropdownButtonCore = (_a, ref) => {
    var { alignment, alternateTheme, children, iconLeft, initialSelection, label = 'Select', onClick, widthPreset } = _a, rest = __rest(_a, ["alignment", "alternateTheme", "children", "iconLeft", "initialSelection", "label", "onClick", "widthPreset"]);
    const [selection, setSelection] = useState(initialSelection);
    const [showChildren, setShowChildren] = useState(false);
    const onClickTrigger = (event) => {
        if (onClick) {
            onClick(event);
            return;
        }
        setShowChildren((val) => !val);
    };
    const deselect = () => {
        setShowChildren(false);
        setSelection(undefined);
    };
    const select = (val) => {
        setShowChildren(false);
        setSelection(val);
    };
    const showOptions = () => setShowChildren(true);
    const toggleOptions = () => setShowChildren((val) => !val);
    useImperativeHandle(ref, () => {
        return {
            active: showChildren,
            deselect,
            select,
            showOptions,
            toggleOptions,
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(CFButton, Object.assign({ alignment: alignment, iconLeft: iconLeft, iconRight: 'chevron-small-down', onClick: onClickTrigger, rounded: true, variant: alternateTheme ? 'control-alternate' : 'control', widthPreset: widthPreset }, commonAttrs(rest)), selection || label),
        showChildren && children));
};
export const CFDropdownButton = forwardRef(CFDropdownButtonCore);
